import { zodResolver } from '@hookform/resolvers/zod'
import { conditionalRender } from '@repo/toolkit/conditional-render'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { getEnrollmentEmails } from '../../../../api/enrollments/get-enrollment-emails'
import { MedicalAttestationResendingInput } from '../../../../lib/types/models/medical-attestation-sending/medical-attestation-sending'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledSelectInput from '../../../elements/inputs/controlled-select-input'
import LoadingScreen from '../../../elements/loading/loading-screen'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<MedicalAttestationResendingInput> & {
  enrollmentId: number
  defaultValues?: MedicalAttestationResendingInput
}

const formSchema: ZodType<MedicalAttestationResendingInput> = z.object({
  sentTo: createStringSchema('Destinataire')
})

const ResendMedicalStatementForm = ({
  enrollmentId,
  defaultValues,
  ...validationButtonProps
}: Props) => {
  const form = useForm<MedicalAttestationResendingInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  const { data: emails } = useQuery({
    queryKey: ['enrollment-emails', enrollmentId],
    queryFn: () => getEnrollmentEmails(enrollmentId)
  })

  if (!emails) return <LoadingScreen />

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={'flex gap-4 flex-col p-3'}>
          <FormField
            control={form.control}
            name={'sentTo'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledSelectInput
                    {...field}
                    searchable
                    allowNewOption
                    label={'Destinataire'}
                    options={emails?.map((email) => ({ label: email, value: email }))}
                    selectedOption={conditionalRender(!!field.value, {
                      label: field.value,
                      value: field.value
                    })}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default ResendMedicalStatementForm
